import { errorMessage } from "../utils/errorMessage";

// Runs a batch change, refreshes the list and raises a toast; with `undo` the toast offers an Undo button.
// Resolves true when the change succeeded.
export default function useBatchRunner(setToast) {
  return async (change, refresh, describe, undo) => {
    try {
      const result = await change();
      await refresh();
      setToast({
        message: describe(result),
        type: "success",
        action: undo ? {
          label: "Undo",
          onClick: async () => {
            try {
              await undo(result);
              await refresh();
              setToast({ message: "Change undone.", type: "success" });
            } catch (err) {
              setToast({ message: errorMessage(err, "Undo failed."), type: "error" });
            }
          },
        } : null,
      });
      return true;
    } catch (err) {
      setToast({ message: errorMessage(err, "Batch change failed."), type: "error" });
      return false;
    }
  };
}
